import React from 'react';
import { motion } from 'framer-motion';
import { Search, Download, MessageCircle, Sparkles } from 'lucide-react';

const steps = [
  {
    icon: Search,
    title: 'Notu bul',
    desc: 'Ana sayfadan ara veya bölüm kartından ders seç; onaylı notlar listelenir.',
    color: 'var(--accent-primary)',
  },
  {
    icon: Download,
    title: 'Drive’dan indir',
    desc: 'Giriş yap, tek tıkla notu cihazına indir — Drive sayfasına yönlendirme yok.',
    color: '#06b6d4',
  },
  {
    icon: MessageCircle,
    title: 'Foruma katıl',
    desc: 'Soru sor, not iste veya görsel paylaş — toplulukla birlikte öğren.',
    color: '#8b5cf6',
  },
];

const HowItWorks: React.FC = () => (
  <section className="page-section" style={{ paddingTop: '48px', paddingBottom: '48px' }}>
    <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        style={{ textAlign: 'center', marginBottom: '48px' }}
      >
        <div className="section-badge" style={{ margin: '0 auto 16px' }}>
          <Sparkles size={14} />
          Nasıl çalışır?
        </div>
        <h2
          style={{
            fontSize: 'clamp(1.5rem, 4vw, 2.25rem)',
            fontWeight: 800,
            margin: '0 0 12px',
            fontFamily: "'Space Grotesk', sans-serif",
          }}
        >
          <span className="gradient-text-white">Üç adımda not ekosistemi</span>
        </h2>
        <p style={{ color: '#94a3b8', fontSize: '15px', maxWidth: '480px', margin: '0 auto', lineHeight: 1.6 }}>
          Keşfet, indir ve toplulukla paylaş — hepsi tek platformda.
        </p>
      </motion.div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '20px',
        }}
      >
        {steps.map((step, i) => {
          const Icon = step.icon;
          return (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="glow-card"
              style={{
                padding: '28px 24px',
                borderRadius: 'var(--radius-card, 22px)',
                position: 'relative',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  fontSize: '48px',
                  fontWeight: 900,
                  color: 'rgba(255,255,255,0.04)',
                  fontFamily: "'Space Grotesk', sans-serif",
                  lineHeight: 1,
                }}
              >
                {i + 1}
              </div>
              <div
                style={{
                  width: '52px',
                  height: '52px',
                  borderRadius: '14px',
                  background: `${step.color}18`,
                  border: `1px solid ${step.color}40`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '18px',
                }}
              >
                <Icon size={24} color={step.color} />
              </div>
              <h3
                style={{
                  margin: '0 0 8px',
                  fontSize: '1.1rem',
                  fontWeight: 700,
                  fontFamily: "'Space Grotesk', sans-serif",
                }}
              >
                {step.title}
              </h3>
              <p style={{ margin: 0, color: '#94a3b8', fontSize: '14px', lineHeight: 1.6 }}>{step.desc}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default HowItWorks;
